import { jwtDecode } from "jwt-decode";

/**
 * Decode the payload of a JWT without verifying its signature.
 *
 * The admin only reads claims the backend already validated (`exp`,
 * `tenantName`). Wrapped so both call sites keep the null-on-garbage
 * contract they had with the previous library.
 *
 * @param {string} token
 * @returns {object|null} payload, or null when the token is malformed
 */
export function decodeJwt(token) {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}
